export default class VanillaPageTab {
  constructor(selector = "#js-page-tab") {
    this.root = document.querySelector(selector);
    if (!this.root) return;
    this.triggers = this.root.querySelectorAll(".js-page-tab-trigger");
    this.contents = this.root.querySelectorAll(".js-page-tab-cnt");
    if (!this.triggers.length || !this.contents.length) return;
    this.bindEvents();
  }
  bindEvents() {
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => {
        this.changeTab(index);
      });
    });
  }
  changeTab(index) {
    this.triggers.forEach((trigger) => trigger.classList.remove("is-active"));
    this.contents.forEach((content) => content.classList.remove("is-active"));
    if (this.triggers[index]) this.triggers[index].classList.add("is-active");
    if (this.contents[index]) this.contents[index].classList.add("is-active");
  }
}
